import { parse } from 'qs'
const appGlobalProps = global.appGlobalProps || {}

export const locale =
  document.documentElement && document.documentElement.lang
    ? document.documentElement.lang
    : 'en-US'
export const location = locale.toLocaleLowerCase()
export const language = location.split('-')[0]
export const region = location.split('-')[1]
export const calendarLocale = locale === 'no-NO' ? 'nb' : locale
export const regionSeparator = location.split('-')[1] === 'us' ? ',' : '.'

const overrideDomain = global?.localStorage?.getItem('override-domain')
export const contentApi = overrideDomain
  ? `${overrideDomain}${process.env.VUE_APP_CONTENT_API}`
  : process.env.VUE_APP_CONTENT_API
export const bookingOcicoApi = overrideDomain
  ? `${overrideDomain}${process.env.VUE_APP_BOOKING_OCICO_API}`
  : process.env.VUE_APP_BOOKING_OCICO_API
export const bookingApi = overrideDomain
  ? `${overrideDomain}${process.env.VUE_APP_BOOKING_MANAGEMENT_API}`
  : process.env.VUE_APP_BOOKING_MANAGEMENT_API
export const loyaltyApi = overrideDomain
  ? `${overrideDomain}${process.env.VUE_APP_LOYALTY_API}`
  : process.env.VUE_APP_LOYALTY_API
export const availabilityApi = overrideDomain
  ? `${overrideDomain}${process.env.VUE_APP_AVAILABILITY_API}`
  : process.env.VUE_APP_AVAILABILITY_API
export const emailApi = overrideDomain
  ? `${overrideDomain}${process.env.VUE_APP_EMAIL_API}`
  : process.env.VUE_APP_EMAIL_API
export const zimbaApi = overrideDomain
  ? `${overrideDomain}${process.env.VUE_APP_ZIMBA_API}`
  : process.env.VUE_APP_ZIMBA_API
export const ombtApi = overrideDomain
  ? `${overrideDomain}${process.env.VUE_APP_OMBT_API}`
  : process.env.VUE_APP_OMBT_API

export const assetsUrl = appGlobalProps.assetsUrl || process.env.VUE_APP_ASSETS_URL
export const googleMapsApiKey = window.googleMapsApiKey || 'gme-radissonhospitality' // TODO: Pass from tridion
export const defaultImage = `${assetsUrl}/img/default-offer-card.jpg`

export function isUpcomingMyAccountFF() {
  const configDynamicKeys = JSON.parse(localStorage.getItem('config-dynamic-keys'))
  return configDynamicKeys && configDynamicKeys['upcoming.my-account.active'] === 'true'
}

export function isFlagActive(configDynamicKey) {
  return (
    global.ConfigDynamic &&
    global.ConfigDynamic.isEnabled({ key: configDynamicKey, defaultValue: 'false' })
  )
}

export function getValueFromConfig(configDynamicKey) {
  return (
    global.ConfigDynamic && global.ConfigDynamic.valueOf(global.ConfigDynamicKey[configDynamicKey])
  )
}

export function isProfileCompletionEnabledV2() {
  const configDynamicKeys = JSON.parse(localStorage.getItem('config-dynamic-keys'))
  return configDynamicKeys && configDynamicKeys['default.profile.completion.enabled.v2'] === 'true'
}

export function consentPiplEnabled(countryCode) {
  const value = global.ConfigDynamic.valueOf(global.configDynamicKey.DEFAULT_PIPL_COUNTRY_CODES)
  return value?.split(',')?.some(cnCountry => cnCountry === countryCode)
}

export const LandingTypes = {
  GENERAL: 'general',
  OFFERS: 'offers',
  DIRECTORY: 'directory',
  PROFILE: 'profile',
  RESERVATIONS: 'reservations',
  ACCOUNT: 'account',
  REGISTERED_OFFERS: 'registeredOffers',
  SIGNUPB2C: 'signupb2c',
  SIGNUPB2B: 'signupb2b',
  INTERACTIVEMAP: 'interactivemap',
  ACCOUNTNLP: 'account-nlp',
  MULTIOFFERS: 'multioffers',
  PROMOCODES: 'promocodes',
  DISCOVERY: 'landingDiscovery',
  DESTINATION: 'landingDestination',
  DESTINATIONCOUNTRYCITY: 'destinationCountryCity',
  POINTTRANSFER: 'pointTransfer',
  RESERVATION_SUMMARY: 'booking-summary',
  POINTTRANSFERSUMMARY: 'pointTransferSummary',
  POINTTRANSFERCONFIRMATION: 'pointTransferConfirmation',
  MANAGE_MEMBERS: 'manageMembers',
  STATEMENTSNLP: 'statements-nlp',
  RHGINSTRUCTIONSMAP: 'rhginstructionsmap'
}

export const FilterPointsDirectory = {
  MIN: 15000,
  MAX: 112000
}
export const FilterPaginationDirectory = {
  LIMIT: 9,
  OFFSET: 0
}
export const MyReservationsDirectory = {
  LIMIT: 2,
  B2B_LIMIT: 4,
  FIRST_LIMIT: 4,
  NEXT_LIMIT: 8,
  PAST_LIMIT: 5,
  PAST_NEXT_LIMIT: 5
}

export const MyReservationsEvents = {
  LIMIT: 5,
  FIRST_LIMIT: 5,
  NEXT_LIMIT: 10
}

export const ManageMembersDirectory = {
  FIRST_LIMIT: 12,
  NEXT_LIMIT: 12
}

export const NlpTransactionsDirectory = {
  FIRST_LIMIT: 6,
  NEXT_LIMIT: 6
}

export const NlpTransactionsType = {
  EARN: 'EARN',
  REDEEM: 'REDEEM'
}

export const NlpTransactionsCategory = {
  MEETING_AND_EVENTS: 'MEETING_AND_EVENTS',
  STAY_POINTS: 'STAY_POINTS',
  TRANSFER: 'TRANSFER',
  PARTNER: 'PARTNER',
  DONATION: 'DONATION',
  OTHER: 'OTHER'
}

export const TiersBenefits = {
  CLUB: 'club',
  PLATINUM: 'platinum',
  PREMIUM: 'premium',
  VIP: 'vip',
  GOLD: 'gold',
  CORP: 'corp'
}

export const CrowdTypes = {
  DISCOUNT: 'CR_DISC',
  TRIPLE_POINTS: 'CR_POINTS'
}

export const ProgramTypes = {
  B2B: 'B2B',
  B2C: 'B2C',
  CORPORATE: 'CORP'
}

export const R4U_PROFILE_TYPES = ['PCR-A', 'PCR-B', 'TMC-A', 'TMC-B']
export const R4U_ADMIN_PROFILE_TYPES = ['PCR-A', 'TMC-A']
export const RR_ADMIN_PROFILE_TYPES = ['B2B-A', 'CORP-A']

export const MemberTypes = {
  BUSINESS: 'business',
  PERSONAL: 'personal'
}

export const StayOptionsTypes = {
  GREENHKP: 'greenhkp',
  ROOM: 'room',
  EXTRA: 'extra',
  MEAL_PLAN: 'meal_plan',
  EXPERIENCE: 'experience'
}

export const roomDisplayUrl = `/${location}${process.env.VUE_APP_ROOM_DISPLAY_URL}`
export const rewardsRedeemUrl = `/${location}${process.env.VUE_APP_REWARDS_REDEEM_URL}`
export const pointTransferUrl = `/${location}${process.env.VUE_APP_POINT_TRANSFER_URL}`
export const pointTransferSummaryUrl = `/${location}${process.env.VUE_APP_POINT_TRANSFER_SUMMARY_URL}`
export const pointTransferConfirmationUrl = `/${location}${process.env.VUE_APP_POINT_TRANSFER_CONFIRMATION_URL}`
export const modifyPromoCodePageUrl = `/${location}${process.env.VUE_APP_MODIFY_PROMO_CODE_URL}`
export const corporateUrl = `/${location}${process.env.VUE_APP_CORPORATE_URL}`
export const corporateMembersUrl = `/${location}${process.env.VUE_APP_CORPORATE_MEMBERS_URL}`
export const transferPointsUrl = `/${location}${process.env.VUE_APP_TRANSFER_POINTS_URL}`
export const contactUsUrl = `/${location}${process.env.VUE_APP_CONTACT_US_URL}`

export const landingType = appGlobalProps.landingType || 'general'
export const numberOfOffers = 20
export const transferMinSeniorityDay = 30
export const tridionLabels = window.tridionLabels || {}
export const errorLabels = window.tridionLabels || {}
// TODO: Remove FF after baidu maps fully deployed
export const showBaiduMapsFF = localStorage.getItem('baidu-map-init') === 'true'
const passwordMustBeRegex =
  appGlobalProps.passwordMustBeRegex ||
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z,;:@+¿?¡!&+*%-_¨´`^($/\\·=#"|~{})]{8,20}$/

export const FormRegex = {
  PHONE: /^([^=,^?]*)$/,
  PASSWORD: passwordMustBeRegex,
  INPUT_TEXT: /^[\p{L}\p{M}\p{N}\p{Pc}\p{Pd}\p{Zs}'’`´\-\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF]{1,35}$/u,
  INPUT_TRANSLITERATE_CHAR_EXCEPTION: /^([^0-9=,^¿?!¡%.*#+&{}:;]*)$/,
  REWARDS_NUMBER: /^[0-9 ]*$/
}

export const formatNumWithSeparator = (num, separator = '.') => {
  if (!num) {
    return 0
  }
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${separator}`)
}

export const formatNumWithSeparatorLang = num => {
  if (!num) {
    return 0
  }
  const userLanguage =
    navigator && navigator.language ? navigator.language.toLocaleLowerCase() : 'en-us'
  return num.toLocaleString(userLanguage)
}

export const formatRewardsNumber = num => {
  if (!num) return ''
  return num
    .toString()
    .match(/\d{4}/g)
    .join(' ')
}

export const isChina = appGlobalProps.isChina
export const onlinePaymentError = appGlobalProps.onlinePaymentError || undefined

export const userTypes = {
  MEETINGS_AND_EVENTS: 'meetings_and_events',
  TRAVEL_ARRENGER: 'travel_arranger',
  TRAVEL_AGENT: 'travel_agent',
  TRAVEL_AGENT_MEETINGS_AND_EVENTS: 'travel_agent_meeting_and_events',
  TRAVEL_ARRENGER_MEETINGS_AND_EVENTS: 'travel_arranger_meeting_and_events'
}

export const monthsOfYear = [
  { code: '01', name: 'Jan' },
  { code: '02', name: 'Feb' },
  { code: '03', name: 'Mar' },
  { code: '04', name: 'Apr' },
  { code: '05', name: 'May' },
  { code: '06', name: 'Jun' },
  { code: '07', name: 'Jul' },
  { code: '08', name: 'Aug' },
  { code: '09', name: 'Sep' },
  { code: '10', name: 'Oct' },
  { code: '11', name: 'Nov' },
  { code: '12', name: 'Dec' }
]

export const creditCards = [
  { code: 'vi', icon: 'visa' },
  { code: 'mc', icon: 'mastercard' },
  { code: 'lu', icon: 'lufhtansa' },
  { code: 'ax', icon: 'amex' },
  { code: 'dc', icon: 'diners-club' },
  { code: 'ab', icon: 'australia-bankcard' },
  { code: 'bx', icon: 'banamex' },
  { code: 'bc', icon: 'bca' },
  { code: 'cb', icon: 'carte-blanche' },
  { code: 'up', icon: 'union-pay' },
  { code: 'cl', icon: 'corporate-lodging-card' },
  { code: 'dr', icon: 'der-travel-voucher' },
  { code: 'di', icon: 'discover' },
  { code: 'dv', icon: 'discover-voucher' },
  { code: 'ef', icon: 'eftpos' },
  { code: 'ec', icon: 'eurocard' },
  { code: 'gw', icon: 'great-wall' },
  { code: 'hl', icon: 'hapag' },
  { code: 'iv', icon: 'iata' },
  { code: 'im', icon: 'intl-monetary' },
  { code: 'jc', icon: 'japanese-credit-boreau' },
  { code: 'nm', icon: 'neiman-marcus' },
  { code: 'ov', icon: 'override' },
  { code: 'wl', icon: 'wagonlit' },
  { code: 'wv', icon: 'wholesale' },
  { code: 'vir', icon: 'rhg-rewards' },
  { code: 'al', icon: 'alipay' },
  { code: 'da', icon: 'dankort' },
  { code: 'pap', icon: 'paypal' },
  { code: 'ru', icon: 'rupay' },
  { code: 'wc', icon: 'wechat-pay' },
  { code: 'sofo', icon: 'sofort' },
  { code: 'alcn', icon: 'alipay-china' },
  { code: 'ap', icon: 'apple-pay' },
  { code: 'baid', icon: 'baidu-wallet' },
  { code: 'ba', icon: 'bank-axept' },
  { code: 'gop', icon: 'google-pay' },
  { code: 'ma', icon: 'maestro' },
  { code: 'mobp', icon: 'mobile-pay' },
  { code: 'payt', icon: 'paytm' },
  { code: 'upi', icon: 'upi' },
  { code: 'vps', icon: 'vipps' }
]

export const tierColors = [
  { name: 'vip', color: '#242424' },
  { name: 'club', color: '#382246' },
  { name: 'premium', color: '#53565A' }
]

export const CrowdAndPoints = (crowd, points, tier, labels = CrowdAndPointsLabels) => {
  if (tier !== 'club' && !points) return labels[2]
  if (!crowd || (crowd === 'CR_POINTS' && points)) return labels[0]
  if (!points) return labels[1]
  if (crowd && points) return labels[2]
  return ''
}
export const CrowdAndPointsLabels = ['prYourPoints', 'prYourDiscount', 'prYourCrowdAndPoints']

export const isLocalEnviroment = window.location.host.includes('localhost')

export const discoveryLandingPageUrl = `/${location}/promotions`

export const taxRegion = key => {
  const akamaiCookie = global.Cookie.read(global.cookieDictionary.akamai)
  const countryCookie = akamaiCookie && parse(akamaiCookie).country
  return (
    global.ConfigDynamic &&
    countryCookie &&
    global.ConfigDynamic.valueOf(global.configDynamicKey[key])
      .split(',')
      .some(country => country === countryCookie)
  )
}

export const expiredOffer = appGlobalProps?.offersData?.expired

export const offerFilters = [
  'category',
  'country',
  'city',
  'startDate',
  'endDate',
  'brand',
  'isRewardsOnly',
  'region',
  'latitude',
  'longitude',
  'distance',
  'offset',
  'codes'
]

export const BookingRestrictionInfo = [
  { code: 'MODIFIABLE_ONLY_ONCE', name: 'prModifiableOnlyOnce' },
  { code: 'MODIFIABLE_DAYS_PRIOR', name: 'prModifiableDaysPrior' },
  { code: 'NON_MODIFIABLE', name: 'prNotModifiable' }
]

export const typeOptions = [
  { code: 'EARN', name: 'psEarn' },
  { code: 'REDEEM', name: 'psRedeem' }
]

export const categoryOptions = [
  { code: 'MEETING_AND_EVENTS', name: 'psMeetingAndEvents' },
  { code: 'STAY_POINTS', name: 'psStayPoints' },
  { code: 'TRANSFER', name: 'psTransfer' },
  { code: 'PARTNER', name: 'psPartner' },
  { code: 'DONATION', name: 'psDonation' },
  { code: 'OTHER', name: 'psOther' }
]

const transferErrorTypes = {
  POINTS_LIMIT_EXCEED: 'problem:corporate-transferring-exceeded-points-quantity',
  TRANSFER_LIMIT_EXCEED: 'problem:corporate-transferring-exceeded-maximum-number-of-transfers'
}

export const transferErrorContent = {
  [transferErrorTypes.POINTS_LIMIT_EXCEED]: {
    title: 'errLimitOfPointsByMonthTitle',
    content: 'errLimitOfPointsByMonthDescription'
  },
  [transferErrorTypes.TRANSFER_LIMIT_EXCEED]: {
    title: 'errLimitOfTransactionsByMonthTitle',
    content: 'errLimitOfTransactionsByMonthDescription'
  }
}

export const documentOptions = {
  TYPE: 'type',
  NUMBER: 'number',
  ISSUEDATE: 'issueDate',
  EXPIRATIONDATE: 'expirationDate',
  NATIONALITY: 'nationality',
  CONSENTSHOW: 'consentShow'
}

export const addressOptions = {
  CITY: 'city',
  COUNTRYCODE: 'countryCode',
  POSTALCODE: 'postalCode',
  STATE: 'state',
  STREET: {
    NAME: 'name',
    NUMBER: 'number'
  }
}

export const isEnvOptionsFFEnabled = () =>
  global.ConfigDynamic &&
  global.ConfigDynamic.isEnabled(global.ConfigDynamicKey.BOOKING_CHECKOUT_GREENHOUSE)

export const OcicoUpsellEmailConsents = ['consentEmailOCI', 'consentEmailUpsell']

export const OcicoWhatsAppConsent = ['consentOCIWhatsapp']
export const ConsentsStatusTypes = {
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  PENDING: 'PENDING'
}

export const B2CIds = ['birthDate', 'children', 'reasonForTravel']

export const B2BMEIds = ['sizeOfUsualEvents', 'numberOfEventsPerYear', 'industries', 'meRole']

export const B2BTAIds = [
  'numberOfReservationsPerYear',
  'reasonForBooking',
  'typeOfBookingDestination',
  'topCityDestinations',
  'typeOfHotelsBooked',
  'mostInterestedBrand'
]

export const MAX_STAY = 90

export const GuaranteeTypes = {
  CREDIT_CARD: 'creditCard',
  CASH_DEPOSIT: 'cashDeposit',
  NON_GUARANTEED: 'nonGuaranteed',
  RADISSON_REWARDS_POINTS: 'radissonRewardsPoints',
  TRAVEL_AGENCY: 'travelAgency',
  COMPANY: 'company'
}

export const SearchTypes = {
  LOWEST: 'lowest',
  TRAVEL_AGENCY: 'travelAgency',
  CORPORATE_ACCOUNT: 'corporateAccount'
}
